import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@b_v/components';
import { Button } from '@bice_vida/ds-components-button';
import Spot from '@src/components/InsuranceCard/Spot';
import { QUOTATION_FULL } from '@src/constants/urls';
import useDevice from '@src/hooks/screen/useDevice';
import useFlowStore, { supportedFlowsEnum } from '@src/stores/useFlowStore';
import Image from 'next/image';
import { useRouter } from 'next/router';

import circleConfig from './circleConfig';
import LandingBenefitsStepsIcon from './LandingBenefitsStepsIcon';

import styles from './LandingBenefitsSteps.module.scss';

const LandingBenefitsSteps = () => {
  const { top, bottom } = circleConfig.signDesktop;
  const { isDesktop } = useDevice();
  const { t } = useTranslation();
  const { setFlowName } = useFlowStore();
  const router = useRouter();

  const handleQuotationClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    setFlowName(supportedFlowsEnum.traditional) as string;
    router.push(QUOTATION_FULL);
  };

  return (
    <div className={styles.LandingBenefitsSteps}>
      <div className={styles.LandingBenefitsSteps__sign__container}>
        <div className={styles.LandingBenefitsSteps__sign_container_image}>
          <Image
            src={
              isDesktop
                ? '/images/bicente/bicente_completo_apuntando.png'
                : '/images/bicente/bicente_apuntando_3.png'
            }
            fill
            alt=""
          />
        </div>

        <div className={styles.LandingBenefitsSteps__sign__container__body}>
          <Text tag="h1" className={styles.LandingBenefitsSteps__sign__container__body__title}>
            <Trans components={{ span: <span /> }}>BENEFITS_STEPS_TITLE</Trans>
          </Text>

          <div className={styles.LandingBenefitsSteps__sign__container__body__steps}>
            {[0, 1, 2].map((step) => (
              <div
                key={`benefitStep_${step}`}
                className={styles.LandingBenefitsSteps__sign__container__body__step}
              >
                {step === 0 && <div className={styles.lineSteps} />}
                <div className={styles.LandingBenefitsSteps__sign__container__body__item}>
                  {step + 1}
                </div>
                <Text
                  tag="p"
                  className={styles.LandingBenefitsSteps__sign__container__body__item_text}
                >
                  <Trans components={{ span: <span /> }}>{t(`BENEFITS_STEPS.${step}`)}</Trans>
                </Text>
              </div>
            ))}
          </div>

          <Button size="xl" onClick={handleQuotationClick}>
            {t('BENEFITS_STEPS_BUTTON')}
          </Button>
        </div>

        <LandingBenefitsStepsIcon />

        {isDesktop && (
          <>
            <Spot width={top.width} height={top.height} classNames={[top.className]} />
            <Spot width={bottom.width} height={bottom.height} classNames={[bottom.className]} />
          </>
        )}
      </div>
    </div>
  );
};

export default LandingBenefitsSteps;
